export default __webpack_public_path__ + "static/media/avatar_bg_senju_tsunede.73cfef8e.png";